import { http } from "@/lib/http";

export function fetchPreDraws() {
  return http
    .get("/api/luckydraw/getListOfPreDraws")
    .then((res) => res.data?.data || []);
}

export function uploadPreDraw(payload) {
  return http
    .post("/api/luckydraw/uploadFromPreDraw", payload)
    .then((res) => res.data?.data || {});
}

export function resetLuckyDraw(did) {
  return http
    .post(`/api/luckydraw/resetLuckyDraw/${did}`, {})
    .then((res) => res.data);
}

export function preDrawExportUrl(did) {
  return `${
    import.meta.env.VITE_API_BASE_URL || ""
  }/api/luckydraw/export_predraw_winners?did=${did}`;
}

export function luckyDrawPickerUrl(did) {
  return `https://aspials.com/lucky-draw-picker/?did=${did}`;
}
